import { render } from "./AdminUsersView.vue?vue&type=template&id=159c2705"
import script from "./AdminUsersView.vue?vue&type=script&lang=js"
export * from "./AdminUsersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__